import { createContext, useContext, useState } from "react";

const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useState(() => {
    const savedUser = localStorage.getItem('x_u');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const loginUser = (user) => {
    setLoggedInUser(user);
    localStorage.setItem('x_u', JSON.stringify(user)); 
    // localStorage.setItem('x_u', JSON.stringify(user?.roles[0].pages)); 
  };

  const logoutUser = () => {
    setLoggedInUser(null);
    localStorage.removeItem('x_u'); 
    localStorage.removeItem('x_t'); 
  };

  return (
    <UserContext.Provider value={{ loginUser, logoutUser, loggedInUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);

export default UserContextProvider;